import { render } from "./CurrentStamps.vue?vue&type=template&id=bfe9948c&scoped=true"
import script from "./CurrentStamps.vue?vue&type=script&lang=js"
export * from "./CurrentStamps.vue?vue&type=script&lang=js"

import "./CurrentStamps.vue?vue&type=style&index=0&id=bfe9948c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe9948c"]])

export default __exports__